export default "__VITE_ASSET__BmzliXvO__"